import React from "react";
import Image from "next/image";

interface ContactModalProps {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ContactModal = ({ setModalOpen }: ContactModalProps) => {
  return (
    <>
      {/* Background Overlay */}
      <div
        className="fixed inset-0 w-screen h-screen bg-black/50 z-[99999]"
        onClick={() => setModalOpen(false)}
      ></div>

      {/* Modal Content */}
      <div
        className="fixed inset-0 flex w-screen h-screen items-center justify-center z-[100000] px-6"
        onClick={() => setModalOpen(false)}
      >
        <div
          className="bg-white rounded-[20px] shadow-xl w-fit flex flex-col items-center relative px-12 py-9 gap-9"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            onClick={() => setModalOpen(false)}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.0002 0L7.99929 6L1.99982 0L0 2L5.99947 8L0 14L1.99982 16L7.99929 10L14.0002 16L16 14L10.0005 8L16 2L14.0002 0Z"
                className="fill-[#666666]/80"
              />
            </svg>
          </button>

          <h2 className="text-3xl font-serifText text-gray-900 text-center max-w-[224px] sm:max-w-full">
            Hubungi Klinik Natura Terdekat
          </h2>

          <div className="flex flex-col items-center justify-center gap-6">
            <button
              onClick={() => window.open("https://wa.link/hp7luv", "_blank")}
              className="w-fit flex items-center justify-center rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-300 py-2 px-6 gap-2 font-nunito text-white"
            >
              <div className="size-5 sm:size-7 relative">
                <Image
                  src={"/hero/whatsapp-color.png"}
                  alt="cta-icon"
                  fill
                  className="object-contain"
                />
              </div>
              <span className="text-xs md:text-sm font-nunito">
                Hubungi Natura Depok
              </span>
            </button>

            <button
              onClick={() => window.open("https://wa.link/q6bj0u", "_blank")}
              className="w-fit flex items-center justify-center rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-300 py-2 px-6 gap-2 font-nunito text-white"
            >
              <div className="size-5 sm:size-7 relative">
                <Image
                  src={"/hero/whatsapp-color.png"}
                  alt="cta-icon"
                  fill
                  className="object-contain"
                />
              </div>
              <span className="text-xs md:text-sm font-nunito">
                Hubungi Natura Kudus
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
